import { categories } from "../data/bookmarks";
import type { BookmarkCategory } from "../types";

type CategoryTabsProps = {
  active: BookmarkCategory | "All";
  onChange: (category: BookmarkCategory | "All") => void;
};

export function CategoryTabs({ active, onChange }: CategoryTabsProps) {
  return (
    <nav className="category-tabs" aria-label="カテゴリ">
      {(["All", ...categories] as const).map((category) => (
        <button
          key={category}
          type="button"
          className={active === category ? "active" : ""}
          onClick={() => onChange(category)}
        >
          {category}
        </button>
      ))}
    </nav>
  );
}
